import React from 'react';
import { Card, Statistic, Typography } from 'antd';
import { round10, calculateDiff } from 'shared/utils/numbers/round';
import { ComparisonValue } from 'components/common/comparison-value';
import styles from './payment-period-statistic.module.scss';
import type { IPaymentPeriodStatisticProps } from './types';

const { Text } = Typography;

export const PaymentPeriodStatistic: React.FC<IPaymentPeriodStatisticProps> = (props) => {
  const {
    title,
    uncompletedInvoicesAmount,
    value,
    comparisonValue,
    showAmount = true,
    showAvgDaysCreatedToStart = true,
    showAvgDaysStartToCompleted = true,
  } = props;

  const hasValidDaysComparison = comparisonValue && comparisonValue.amount > 0;

  const amountDiff = calculateDiff(value.amount, comparisonValue?.amount);
  const createdToWaitingDiff = calculateDiff(value.avgDaysCreatedToStart, comparisonValue?.avgDaysCreatedToStart);
  const waitingToCompletedDiff = calculateDiff(value.avgDaysStartToCompleted, comparisonValue?.avgDaysStartToCompleted);

  return (
    <Card>
      <Text className={styles.title}>{title}</Text>
      <div className={styles.valuesRow}>
        {showAmount && (
          <div className={styles.valueItem}>
            <Statistic
              value={value.amount}
              precision={0}
              suffix={
                uncompletedInvoicesAmount ? (
                  <Text className={styles.uncompletedInvoices}>({uncompletedInvoicesAmount})</Text>
                ) : null
              }
            />
            {comparisonValue && amountDiff !== 0 && (
              <ComparisonValue value={round10(comparisonValue.amount)} diff={amountDiff} />
            )}
          </div>
        )}

        {showAvgDaysCreatedToStart && (
          <div className={styles.valueItem}>
            <div className={styles.valueWrapper}>
              <Statistic value={value.avgDaysCreatedToStart} suffix='d.' precision={1} />
              <Text className={styles.description}>to waiting</Text>
            </div>
            {hasValidDaysComparison && createdToWaitingDiff !== 0 && (
              <ComparisonValue
                value={round10(comparisonValue.avgDaysCreatedToStart)}
                diff={createdToWaitingDiff}
                suffix='d.'
                invertDiff={true}
              />
            )}
          </div>
        )}

        {showAvgDaysStartToCompleted && (
          <div className={styles.valueItem}>
            <div className={styles.valueWrapper}>
              <Statistic value={value.avgDaysStartToCompleted} suffix='d.' precision={1} />
              <Text className={styles.description}>to completed</Text>
            </div>
            {hasValidDaysComparison && waitingToCompletedDiff !== 0 && (
              <ComparisonValue
                value={round10(comparisonValue.avgDaysStartToCompleted)}
                diff={waitingToCompletedDiff}
                suffix='d.'
                invertDiff={true}
              />
            )}
          </div>
        )}
      </div>
    </Card>
  );
};
